import { useState } from "react";
import { APIError, createPayout } from "../api";
import type { T } from "../i18n";

export function Payouts({ t }: { t: T }) {
  const [recipientID, setRecipientID] = useState("");
  const [currency, setCurrency] = useState("USD");
  const [msg, setMsg] = useState<string | null>(null);

  async function pay() {
    setMsg(null);
    try {
      await createPayout(recipientID, currency);
      setMsg("✓");
    } catch (e) {
      if (e instanceof APIError && e.status === 422) setMsg(t("payouts.none"));
      else setMsg(t("common.error"));
    }
  }

  return (
    <div>
      <div className="form-row">
        <input placeholder={t("payouts.recipient")} value={recipientID} onChange={(e) => setRecipientID(e.target.value)} />
        <input placeholder={t("payouts.currency")} value={currency} onChange={(e) => setCurrency(e.target.value)} />
        <button onClick={pay} disabled={!recipientID || currency.length !== 3}>
          {t("payouts.trigger")}
        </button>
      </div>
      {msg && <p className={msg === "✓" ? "ok" : "error"}>{msg}</p>}
    </div>
  );
}
